import AccountInformation from './components/View';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { IUser } from 'src/utils/interfaces/user';
import { PaymentDataResponse } from 'src/services/models/payment.service';
import PaymentInformation from './components/PaymentInformation';
import PayoffPaymentInformation from './components/PayoffPaymentInformation';
import QuoteInformation from './components/QuoteInformation';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction, useState } from 'react';
import { isBrandAudi, isBrandVW } from 'src/utils/helpers';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import './styles.scss';

export enum Tabs {
    PAYMENT = 'Payment',
    PAYOFF = 'PayOff',
}
interface IProps {
    type: Tabs;
    paymentData: PaymentDataResponse;
    setPaymentInfo: Dispatch<
        SetStateAction<{
            show: boolean;
            type: Tabs;
            paymentData: PaymentDataResponse;
        }>
    >;
}
const PaymentDetails = ({ paymentData, setPaymentInfo, type }: IProps) => {
    const [notify, setNotify] = useState(false);
    const [isError, setError] = useState(false);
    const { payments, payoffPaymentInformation } = useLocalization();
    const [warning, setWarning] = useState(false);
    const { t } = useTranslation();

    const vin = paymentData.accountDetail.vin;

    const currentBrand =
        useSelector((state: IUser) => state.dealerDataInfo?.dealer.brand) ||
        'Volkswagen';
    const brand = isBrandAudi(currentBrand)
        ? 'Audi'
        : isBrandVW(currentBrand)
        ? 'Volkswagen'
        : currentBrand;

    const isSavingsAccount = (type: number): boolean => {
        const savingsId = 2;
        return type === savingsId;
    };

    return (
        <div className='dashboard-content-wrapper'>
            <div className='dashboard-content-container'>
                <div className='payments-information-wrapper'>
                    <section className='o-content-section  '>
                        <div className=''>
                            {notify ? (
                                <div className='u-mb-large'>
                                    <Notification
                                        content=''
                                        contentHtml={
                                            isError
                                                ? payments.PAYMENT_INFORMATION_CREATE_ERROR_MESSAGE
                                                : type == Tabs.PAYOFF
                                                ? t(
                                                      payments.PAYMENT_INFORMATION_PAYOFF_SUCCESS_MESSAGGE,
                                                      {
                                                          vin,
                                                          brand,
                                                      },
                                                  )
                                                : payments.PAYMENT_INFORMATION_CREATE_SUCCESS_MESSAGGE
                                        }
                                        type={
                                            isError
                                                ? NotificationType.ERROR
                                                : NotificationType.SUCCESS
                                        }
                                        visibility={notify}
                                        setVisibility={setNotify}
                                        withoutClose={true}
                                    />
                                </div>
                            ) : null}
                            {warning && (
                                <div className='u-mb-large'>
                                    <Notification
                                        content={
                                            payoffPaymentInformation.ASSIGN_SECURITY_DEPOSIT_WARNING
                                        }
                                        type={NotificationType.WARNING}
                                        visibility={warning}
                                        setVisibility={setWarning}
                                        withoutClose={false}
                                    />
                                </div>
                            )}
                            <h5 className='u-mb-large'>
                                <span className='c-section-heading__title-text'>
                                    {payments.PAYMENT_MAKE_TITLE}
                                </span>
                            </h5>
                            {type == Tabs.PAYOFF &&
                                paymentData.quoteDetails && (
                                    <QuoteInformation
                                        quoteDetails={paymentData.quoteDetails}
                                        accountType={
                                            paymentData.accountDetail
                                                .accountType
                                        }
                                    />
                                )}
                            {type == Tabs.PAYOFF && (
                                <PayoffPaymentInformation
                                    paymentData={paymentData}
                                    isError={isError}
                                    setIsError={setError}
                                    notify={notify}
                                    setNotify={setNotify}
                                    setPaymentInfo={setPaymentInfo}
                                    type={type}
                                    setWarning={setWarning}
                                    isSavings={isSavingsAccount}
                                />
                            )}
                            {type == Tabs.PAYMENT && (
                                <PaymentInformation
                                    paymentData={paymentData}
                                    isError={isError}
                                    setIsError={setError}
                                    notify={notify}
                                    setNotify={setNotify}
                                    setPaymentInfo={setPaymentInfo}
                                    type={type}
                                    isSavings={isSavingsAccount}
                                />
                            )}
                            <AccountInformation
                                data={paymentData}
                            ></AccountInformation>
                        </div>
                    </section>
                    <section className='privacy-footer-container '>
                        <FooterPrivacy />
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PaymentDetails;
